import { Controller } from "@hotwired/stimulus";

// Collapses list items beyond a visible threshold behind a
// "see more / see less" toggle. Items to hide carry the "extra"
// target (plus the hidden class initially); the toggle button holds
// the two label targets.
export default class extends Controller {
  static targets = ["extra", "moreLabel", "lessLabel"];

  toggle() {
    this.extraTargets.forEach((el) => el.classList.toggle("hidden"));
    this.moreLabelTarget.classList.toggle("hidden");
    this.lessLabelTarget.classList.toggle("hidden");
  }
}
